import axios from "../../plugins/axios";
import utils from "../../../utils/utils";

// 销售模块api
class Sale {

    //---------------销售订单相关--------------------------------//
    //INTF-00216：根据工厂、客户、物料信息，获取其下有效的销售视图信息
    getMaterialSaleViewInfo(body) {
        return axios.post(`/myMaterialApp/service.SalesViewProvider/FindOne`, body);
    }

    //INTF-00256：对新建的销售订单进行保存
    addSaleOrderHeader(body) {
        return axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/CreateOne`, body);
    }

    //INTF-00257：分页查询销售订单头
    async getSaleOrderHeaderList(query) {
        let body = query;
        try {
            let res = await axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.sale_order_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get so list in pages failed: INTF-00257", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00258：对草稿的销售订单进行删除
    deleteDraftSo(ids) {
        let body = { id_arr: ids };
        return axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/Delete`, body);
    }

    //INTF-00259：对草稿的销售订单头进行修改。
    modifySoHeader(body) {
        return axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/UpdateDetails`, body);
    }

    //INTF-00260：对新增的销售订单行进行保存
    addSaleOrderLine(body) {
        return axios.post(`/mySaleOrderApp/service.SaleOrderLineProvider/CreateOne`, body);
    }

    //INTF-00261：移除销售订单行
    removeSaleOrderLine(ids) {
        let body = { id_arr: ids };
        return axios.post(`/mySaleOrderApp/service.SaleOrderLineProvider/Delete`, body);
    }

    //INTF-00262：修改销售订单行
    modifySaleOrderLine(body) {
        return axios.post(`/mySaleOrderApp/service.SaleOrderLineProvider/UpdateDetails`, body);
    }


    //INTF-00263：分页查询销售订单头下的订单行
    async getSaleOrderLine(body) {
        try {
            let res = await axios.post(`/mySaleOrderApp/service.SaleOrderLineProvider/FindByHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.sale_order_line_infos = [];
                res.total = 0;
            }
            //做格式调整处理
            res.sale_order_line_infos.forEach((item) => {
                // 补全delivered_qty,loss_qty,received_qty属性
                if (item.delivered_qty === undefined) {
                    item.delivered_qty = 0;
                }
                if (item.loss_qty === undefined) {
                    item.loss_qty = 0;
                }
                if (item.received_qty === undefined) {
                    item.received_qty = 0;
                }
            });
            return res;
        } catch (err) {
            console.log("get so line in pages failed: INTF-00263", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00286：根据销售订单的ID，获取销售订单头的详情信息
    getSoHeaderInfoById(body) {
        return axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/FindOne`, body);
    }

    //INTF-00456：获取尚未完成交货的销售订单头列表
    async getNotCompletelyDeliveredSaleOrderHeaderList(query) {
        let body = query;
        try {
            let res = await axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/FindUnfinished`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.sale_order_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get uncompletely delivered sale order list in pages failed: INTF-00456", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00529：分页查询，查询所有需求数量>客户收货数量的销售订单行信息。按需求交付日期由近到远顺序提供，需要包括该销售订单行所属的销售订单头id、销售订单头编号（能根据销售订单号查询）。用于在待办任务中，提示给库存管理人员查看，避免遗漏出库
    async getWaitForDeliveredSoLineList(query) {
        let body = query;
        try {
            let res = await axios.post(`/mySaleOrderApp/service.SaleOrderLineProvider/FindUnfinished`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.sale_order_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get wait for deliver so line list in pages failed: INTF-00529", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00774：根据公司间交易的采购订单，创建销售订单
    addSoByInternalTradePo(val) {
        let body = val;
        return axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/CreateOneInternalOrder`, body);
    }

    //------------------------文件相关------------------------//
    //00446 获取文件token
    getFileToken(route) {
        let body = { types: "object", values: utils.getUidAndToken(route) };
        return axios.post(`/mySaleOrderApp/service.SaleOrderFileOperateProvider/SaleorderModuleFileUpload`, body);
    }
    //00445 获取文件上传的文件名
    getFileUploadName(fileName, route) {
        let body = { types: "object,object", values: [{ file_name: fileName }, utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.SaleOrderFileOperateProvider/GetSaleorderModuleFileName`, body);
    }

    //00447 上传文件成功后通知服务器
    fileUploadSuccess(soId, dir, fileNames, route) {
        let body = { types: "object,object", values: [{ so_id: soId, fileDir: dir, fileName: fileNames }, utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.SaleOrderFileOperateProvider/FileUploadSuccess`, body);
    }
    //00448 获取文件地址
    getFileTemplate(soId, route) {
        let body = { types: "object,object", values: [{ so_id: soId }, utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.SaleOrderFileOperateProvider/GetSaleorderFileTemplate`, body);
    }
    saleFileDelete(hId, route) {
        let body = { types: "object,object", values: [{ parameter: hId }, utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.SaleOrderFileOperateProvider/SaleorderFileDelete`, body);
    }


    //------------------------销售订单行文件相关操作相关-------------------------//

    //00446 获取文件token
    getSaleLineFileToken(route) {
        let body = { types: "object", values: utils.getUidAndToken(route) };
        return axios.post(`/mySaleOrderApp/service.SaleLineFileProvider/GetFileUploadToken`, body);
    }
    //00445 获取文件上传的文件名
    getSaleLineFileUploadName(fileName, route) {
        let body = { types: "object,object", values: [{ fileName: fileName }, utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.SaleLineFileProvider/GetFileUpName`, body);
    }

    //00447 上传文件成功后通知服务器
    saleLineFileUploadSuccess(dir, fileNames, route) {
        let body = { types: "object,object", values: [{ fileDir: dir, fileName: fileNames }, utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.SaleLineFileProvider/FileUploadSuccess`, body);
    }
    //00448 获取模版文件地址
    getSaleLineFileTemplate(route) {
        let body = { types: "object,object", values: [utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.SaleLineFileProvider/GetFileTemplate`, body);
    }
    //INTF-00575：使用文件批量导入销售订单行
    FileImportSaleLine(dir, fileNamec, fileUidc, rid) {
        let body = { fileDir: dir, fileName: fileNamec, fileUid: fileUidc, parameter: String(rid) };
        return axios.post(`/mySaleOrderApp/service.FileSaleLineProvider/ModuleFileImport`, body);
    }
    //------------------------客户管理相关-----------------------------------//
    //INTF-00250：对新建的客户公司进行保存
    addNewCustmerCompany(body) {
        return axios.post(`/myCustomerApp/service.customercompany.CustomerCompanyProvider/CreateOne`, body);
    }

    //INTF-00251：对修改的客户公司进行保存
    modifyCustomerCompany(body) {
        return axios.post(`/myCustomerApp/service.customercompany.CustomerCompanyProvider/UpdateDetails`, body);
    }

    //INTF-00252：删除草稿客户
    batchDeleteCustomerCompany(arr) {
        let body = { id_arr: arr }
        return axios.post(`/myCustomerApp/service.customercompany.CustomerCompanyProvider/Delete`, body);
    }

    //INTF-00253：分页获取客户公司列表
    async getCustomerCompanyList(body) {
        try {
            let res = await axios.post(`/myCustomerApp/service.customercompany.CustomerCompanyProvider/FindAll`, body);
            let check = utils.isEmptyObject(res);
            if (check) {
                //空对象，补全
                res.total = 0;
                res.customer_company_infos = [];
            }
            return res;
        } catch (err) {
            console.log("get customer company list failed: INTF-00253", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00254：获取不分页的客户列表
    async getCustomerCompanyNoLimit() {
        let body = {};
        try {
            let res = await axios.post(`/myCustomerApp/service.customercompany.CustomerCompanyProvider/FindAllNoLimit`, body);
            let check = utils.isEmptyObject(res);
            if (check) {
                //空对象，补全
                res.total = 0;
                res.customer_company_infos = [];
            }
            return res;
        } catch (err) {
            console.log("get customer company list in no pages failed: INTF-00254", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00297：根据客户ID，获取该客户详情信息
    getDetailCustomerCompanyInfoById(id, route) {
        let body = { types: "object,object", values: [{ id: id }, utils.getUidAndToken(route)] };
        return axios.post(`/myCustomerApp/service.CustomerCompanyProvider/FindOne`, body);
    }


}

export default Sale;